import * as React from 'react'

function VmPAnakGrayIcon({title, titleId, ...props}, svgRef) {
  return React.createElement(
    'svg',
    Object.assign(
      {
        id: 'Layer_1',
        'data-name': 'Layer 1',
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 460 460',
        ref: svgRef,
        'aria-labelledby': titleId,
      },
      props
    ),
    title
      ? React.createElement(
          'title',
          {
            id: titleId,
          },
          title
        )
      : null,
    React.createElement('path', {
      d: 'M7778,3668.28h36c4.92.72,9.83,1.48,14.75,2.16,96.37,13.22,175.93,89.2,193.35,184.74,1.46,8,2.61,16.07,3.91,24.1v39c-.33,1.27-.75,2.53-1,3.83-2.06,11.28-3.25,22.81-6.26,33.83Q7990.27,4060,7892.87,4107c-.29-4.31-.47-8.63-.9-12.92-2.11-21-5.24-41.58-18.69-59-1.65-2.14-2.27-5.53-2.31-8.36-.23-14.78-.07-29.57-.16-44.36,0-3.13-.54-6.25-.83-9.38,20.61-16.68,27.63-38.91,25.39-64.41-1.53-17.38-4.34-34.65-6.41-52-1.16-9.73-2-19.5-3-29.26,1.09-.38,2.17-.83,3.29-1.13,7.36-2,7.68-2,7-9.37-.85-9.93-1.59-19.95-3.54-29.7-5-24.93-18.13-43.16-43.41-51.37-23.53-7.64-47.43-10.54-71.92-7-22.74,3.27-43.08,11.47-57.72,30.35a8.89,8.89,0,0,1-2.72,2.13c-13.4,7.45-21.51,19-26.14,33.35-3.75,11.6-3.8,23.54-3.78,35.58.14,65.79.06,131.57.1,197.36,0,2.62.48,5.24.74,7.86l13.16,1.53c-1.44,1.68-2.15,2.56-2.91,3.39-9.44,10.22-19,20.37-28.29,30.68-3.54,3.91-6.67,8.2-10,12.32a53.47,53.47,0,0,1-5-3.17c-43.68-34.57-71.93-78.89-83.81-133.39-2.26-10.36-3.41-21-5.08-31.45v-36c.95-5.73,1.94-11.44,2.84-17.18,14.83-94,87.2-169.95,180.2-188.92C7758.63,3671.23,7768.34,3669.9,7778,3668.28Z',
      transform: 'translate(-7566 -3668.28)',
      style: {
        fill: '#ababab',
      },
    }),
    React.createElement('path', {
      d: 'M7659.92,4083.28c3.32-4.12,6.44-8.41,10-12.32,9.33-10.31,18.85-20.46,28.29-30.68.76-.83,1.47-1.71,2.91-3.39l-13.16-1.53a49.35,49.35,0,0,1,7-.14c6.41.74,11.42-1.5,16.18-5.8a45.87,45.87,0,0,1,12.82-8.43c17.78-7.32,33.63-18,50-27.8.27,7.13.38,14.27.9,21.37a15,15,0,0,0,2.26,7c8.6,12.85,39.43,11.57,47.09-1.85a17.42,17.42,0,0,0,.92-2.3l.92-24.1a214.23,214.23,0,0,1,42.7,35.76l1.3-.8v-54.76a.81.81,0,0,1,0-.52c.29,3.13.81,6.25.83,9.38.09,14.79-.07,29.58.16,44.36,0,2.83.67,6.23,2.31,8.36,13.45,17.45,16.58,38.07,18.69,59,.43,4.29.61,8.61.9,12.92a213.27,213.27,0,0,1-52.94,17.2c-8.27,1.57-16.62,2.72-24.93,4.06h-39a12.28,12.28,0,0,0-2.72-.94,227.48,227.48,0,0,1-108.84-40.2A57.29,57.29,0,0,1,7659.92,4083.28Z',
      transform: 'translate(-7566 -3668.28)',
      style: {
        fill: '#777',
        stroke: '#777',
      },
    }),
    React.createElement('path', {
      d: 'M7773.89,3993.2c-16.36,9.81-32.21,20.48-50,27.8a45.87,45.87,0,0,0-12.82,8.43c-4.76,4.29-9.77,6.54-16.18,5.8a49.35,49.35,0,0,0-7,.14c-.26-2.62-.74-5.24-.74-7.86,0-65.79,0-131.57-.1-197.36,0-12,0-24,3.78-35.58,4.63-14.33,12.73-25.9,26.14-33.35a8.89,8.89,0,0,0,2.72-2.13c14.64-18.88,35-27.07,57.72-30.35,24.49-3.53,48.39-.63,71.92,7,25.27,8.21,38.42,26.43,43.41,51.37,2,9.75,2.68,19.76,3.54,29.7.63,7.35.32,7.37-7,9.37-1.12.3-2.19.75-3.29,1.13-12.48,1.83-24.91,4.34-37.46,5.36-34.81,2.81-68.73-.81-100.75-16a20.67,20.67,0,0,0-2.59-.89c1.33,9.49,3.56,18.79,3.67,28.11s-1.9,18.76-3,28.14l-10,23.61c-5.85-7.18-12.65-11.07-20.35-14.3-4.27-1.79-7.38-1.67-9.7.91-3.21,3.57-6.43,7.87-7.61,12.4-4.08,15.69,4.31,34.73,18.8,44.65,0,1.32,0,2.65.16,4,.59,5.44,4.57,9.37,9.62,9.59s9-3,10.22-8.28q.52-2.16,1-4.32c3-2.39,3.53.36,4.37,2.21,4.89,10.72,11.37,20.59,21,27.29,8,5.6,12.17,11.86,10.84,21.55Z',
      transform: 'translate(-7566 -3668.28)',
      style: {
        fill: '#363636',
      },
    }),
    React.createElement('path', {
      d: 'M7745.88,3872c1.08-9.38,3.09-18.78,3-28.14s-2.34-18.62-3.67-28.11a20.67,20.67,0,0,1,2.59.89c32,15.19,65.94,18.81,100.75,16,12.55-1,25-3.53,37.46-5.36,1,9.75,1.82,19.53,3,29.26,2.07,17.34,4.88,34.6,6.41,52,2.24,25.49-4.79,47.73-25.39,64.41a.81.81,0,0,0,0,.52,81.63,81.63,0,0,1-39.93,13.83c-3.82-.31-7.64-.56-11.45-.94-29.54-2.92-55.8-25.28-62.16-54.31C7752.12,3912.24,7749.35,3892.06,7745.88,3872Zm128.87-14.78-1.17-1.29c-4.14,0-8.33.4-12.4-.11s-6.39,1.05-8.15,4.22c-3.62,6.56-1.72,17.62,3.84,22.63,4.3,3.88,9.77,3.13,11.68-2.36a24.36,24.36,0,0,0,1-12.6C7868.46,3862.74,7867.06,3858.65,7874.74,3857.26Zm-104.3,18.88c5.91.5,7.66,3.4,8,9.21.19,3.76,2.56,7.91,5.08,10.93,3.89,4.66,9.31,3.4,12-2.09,3.13-6.43,1.54-17.07-3.79-21.74-1.77-1.55-5-3-7-2.44C7779.75,3871.42,7775.16,3874,7770.44,3876.14Zm54.25-11.21-1.67.53c.12,1.78-.1,3.67.41,5.33,2.12,6.82,4.53,13.55,6.68,20.35,1.1,3.47,3,4.87,6.68,3.83,3.23-.91,6.56-.9,7.72,3.15,1.11,3.86-.93,6.26-4.35,7.87a41.49,41.49,0,0,0-4.61,2.94c.78.92,1,1.34,1.2,1.39,5.51,1,12.24-3.76,12.9-9.08.74-5.9-2.95-10.42-9.54-10.82-4.41-.26-6.55-2.28-7.71-6.28-1.44-4.94-3.12-9.82-4.91-14.64A26.6,26.6,0,0,0,7824.69,3864.93ZM7789,3909.3l-.26-.75c-4.7,1.51-9.51,2.76-14,4.68a5.87,5.87,0,0,0-2.77,4.6c0,1.19,2.15,2.89,3.66,3.38,6.33,2,12.64.9,18.41-1.87,2.15-1,3.39-4,5-6-2.19-1.23-4.32-2.59-6.6-3.63C7791.49,3909.2,7790.19,3909.4,7789,3909.3Zm91.1-19.32c-5.52,1.92-10.57,3.34-15.28,5.52-1.51.7-3.13,3.62-2.8,5.11s3.16,3.27,4.8,3.19a70.25,70.25,0,0,0,15-2.28c3.29-.91,8.15-2.4,6.81-6.87C7888.06,3892.53,7883.34,3891.62,7880.13,3890Zm-27.64,47.12-23.22,2.83c.59,7,6,11.19,13.36,10.2C7849.53,3949.21,7853.57,3943.7,7852.49,3937.11Zm10.58-96.22c-3.91.53-6.93.68-9.79,1.45-1.26.34-2.18,1.94-3.25,3,1.32.61,2.6,1.64,4,1.75q9.79.79,19.62,1.09c1.37,0,2.76-.87,4.14-1.34-1-1.13-1.75-2.93-3-3.28C7870.71,3842.31,7866.46,3841.61,7863.07,3840.88Zm-74.91,16.22c-1.69-1.07-2.57-2.1-3.43-2.09a34.82,34.82,0,0,0-22.87,8.59c-.69.59-.42,2.32-.59,3.52,1.18.08,2.75.68,3.47.14a40.87,40.87,0,0,1,19.8-7.7C7785.58,3859.44,7786.49,3858.29,7788.17,3857.1Z',
      transform: 'translate(-7566 -3668.28)',
      style: {
        fill: '#c8c8c8',
      },
    }),
    React.createElement('path', {
      d: 'M7745.88,3872c3.47,20,6.24,40.2,10.59,60,6.36,29,32.62,51.39,62.16,54.31,3.81.38,7.63.63,11.45.94l-4.82,1.65.74,4.32-.92,24.1c0-5.81-.12-11.63-.06-17.44,0-3.9-1.45-4.6-5.28-3.86-7.26,1.41-14.83,3.49-22,2.65-8.05-1-15.76-4.82-23.62-7.42,1.33-9.69-2.85-16-10.84-21.55-9.58-6.71-16.06-16.58-21-27.29-.85-1.86-1.34-4.6-4.37-2.21-7.2-10.43-16-8.58-21-.95-14.49-9.93-22.88-29-18.8-44.65,1.18-4.52,4.4-8.82,7.61-12.4,2.32-2.58,5.43-2.7,9.7-.91,7.7,3.23,14.5,7.12,20.35,14.3Z',
      transform: 'translate(-7566 -3668.28)',
      style: {
        fill: '#afafaf',
        stroke: '#afafaf',
      },
    }),
    React.createElement('path', {
      d: 'M7774.16,3991.32c7.86,2.6,15.56,6.47,23.62,7.42,7.13.84,14.7-1.24,22-2.65,3.82-.74,5.31,0,5.28,3.86-.05,5.81,0,11.62.06,17.44a17.39,17.39,0,0,1-.92,2.3c-7.66,13.42-38.49,14.7-47.09,1.85a15,15,0,0,1-2.26-7c-.53-7.11-.63-14.25-.9-21.37Z',
      transform: 'translate(-7566 -3668.28)',
      style: {
        fill: '#c8c8c8',
      },
    }),
    React.createElement('path', {
      d: 'M7826,3993.28l-.74-4.32,4.82-1.65a81.63,81.63,0,0,0,39.93-13.83v54.76l-1.3.8A214.23,214.23,0,0,0,7826,3993.28Z',
      transform: 'translate(-7566 -3668.28)',
      style: {
        fill: '#363636',
      },
    }),
    React.createElement('path', {
      d: 'M7717,3939.31c5-7.63,13.82-9.48,21,.95q-.51,2.16-1,4.32c-1.25,5.24-5.27,8.49-10.22,8.28s-9-4.15-9.62-9.59C7717,3942,7717,3940.63,7717,3939.31Z',
      transform: 'translate(-7566 -3668.28)',
      style: {
        fill: '#777',
      },
    }),
    React.createElement('path', {
      d: 'M7874.74,3857.26c-7.68,1.39-6.28,5.48-5.18,10.49a24.36,24.36,0,0,1-1,12.6c-1.91,5.49-7.37,6.24-11.68,2.36-5.55-5-7.46-16.06-3.84-22.63,1.75-3.17,4.17-4.72,8.15-4.22s8.26.11,12.4.11Z',
      transform: 'translate(-7566 -3668.28)',
      style: {
        fill: '#363636',
      },
    }),
    React.createElement('path', {
      d: 'M7770.44,3876.14c4.72-2.12,9.31-4.72,14.23-6.13,2-.57,5.21.89,7,2.44,5.33,4.67,6.93,15.31,3.79,21.74-2.67,5.49-8.09,6.74-12,2.09-2.53-3-4.89-7.18-5.08-10.93C7778.1,3879.54,7776.35,3876.65,7770.44,3876.14Z',
      transform: 'translate(-7566 -3668.28)',
      style: {
        fill: '#363636',
      },
    }),
    React.createElement('path', {
      d: 'M7824.69,3864.93a26.6,26.6,0,0,1,2.81,4.57c1.79,4.83,3.47,9.7,4.91,14.64,1.17,4,3.3,6,7.71,6.28,6.59.39,10.28,4.92,9.54,10.82-.67,5.33-7.39,10.08-12.9,9.08-.25,0-.42-.47-1.2-1.39a41.49,41.49,0,0,1,4.61-2.94c3.42-1.61,5.46-4,4.35-7.87-1.16-4.05-4.49-4.06-7.72-3.15-3.72,1-5.59-.36-6.68-3.83-2.15-6.81-4.56-13.54-6.68-20.35-.51-1.66-.3-3.55-.41-5.33Z',
      transform: 'translate(-7566 -3668.28)',
      style: {
        fill: '#b0b0b0',
      },
    }),
    React.createElement('path', {
      d: 'M7789,3909.3c1.16.1,2.45-.1,3.45.36,2.28,1,4.41,2.4,6.6,3.63-1.65,2.07-2.89,5-5,6-5.78,2.77-12.08,3.91-18.41,1.87-1.51-.48-3.63-2.19-3.66-3.38a5.87,5.87,0,0,1,2.77-4.6c4.52-1.92,9.33-3.17,14-4.68Z',
      transform: 'translate(-7566 -3668.28)',
      style: {
        fill: '#bfbfbf',
      },
    }),
    React.createElement('path', {
      d: 'M7880.13,3890c3.21,1.63,7.93,2.54,8.57,4.67,1.34,4.46-3.52,6-6.81,6.87a70.25,70.25,0,0,1-15,2.28c-1.64.08-4.49-1.78-4.8-3.19s1.29-4.41,2.8-5.11C7869.56,3893.33,7874.61,3891.91,7880.13,3890Z',
      transform: 'translate(-7566 -3668.28)',
      style: {
        fill: '#bebebe',
      },
    }),
    React.createElement('path', {
      d: 'M7852.49,3937.11c1.08,6.59-3,12.1-9.86,13-7.37,1-12.77-3.19-13.36-10.2Z',
      transform: 'translate(-7566 -3668.28)',
      style: {
        fill: '#fdfdfd',
      },
    }),
    React.createElement('path', {
      d: 'M7863.07,3840.88c3.39.72,7.64,1.43,11.74,2.63,1.2.35,2,2.15,3,3.28-1.38.47-2.78,1.38-4.14,1.34q-9.82-.3-19.62-1.09c-1.36-.11-2.64-1.14-4-1.75,1.07-1,2-2.62,3.25-3C7856.14,3841.56,7859.16,3841.42,7863.07,3840.88Z',
      transform: 'translate(-7566 -3668.28)',
      style: {
        fill: '#383838',
      },
    }),
    React.createElement('path', {
      d: 'M7788.17,3857.1c-1.68,1.18-2.58,2.34-3.62,2.47a40.87,40.87,0,0,0-19.8,7.7c-.72.54-2.3-.07-3.47-.14.17-1.2-.1-2.93.59-3.52a34.82,34.82,0,0,1,22.87-8.59C7785.6,3855,7786.48,3856,7788.17,3857.1Z',
      transform: 'translate(-7566 -3668.28)',
      style: {
        fill: '#383838',
      },
    })
  )
}

const ForwardRef = React.forwardRef(VmPAnakGrayIcon)
export default ForwardRef
